import React from "react"
import Container from "../../atoms/Container"
import "./TekstContent.css"

export default function TekstContent({ block }) {
  console.log(block)
  return (
    <Container>
      <div className="vt-whitespace-container"></div>
      <div className="vt-content-container">
        <h2>{block.title}</h2>
        <p dangerouslySetInnerHTML={{ __html: block.content }}></p>
      </div>
      <div className="vt-whitespace-container"></div>
    </Container>
  )
}
